var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-base", {
    ref: "form",
    staticClass:
      "newsletter-subscription-form bg-brown-400 p-16 lg:px-[60px] lg:py-[50px]",
    on: { submit: _vm.submit },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var loading = ref.loading
          var success = ref.success
          return [
            _c(
              "div",
              {
                staticClass: "text-orange font-semi",
                class: {
                  "text-30": _vm.mode === "large",
                  "text-22 mb-24": _vm.mode === "small"
                }
              },
              [_vm._v("nieuwsbrief")]
            ),
            _vm._v(" "),
            _vm.mode === "large"
              ? _c(
                  "div",
                  { staticClass: "text-white font-extraBold text-40" },
                  [_vm._v("Blijf op de hoogte")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.mode === "large"
              ? _c(
                  "div",
                  { staticClass: "text-white font-medium text-18 mb-24" },
                  [
                    _vm._v(
                      "Het allerlaatste nieuws, boeiende verhalen en leerrijke tips."
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("form-error", {
              attrs: { "error-response": _vm.errorResponse }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "grid grid-cols-1 gap-32": _vm.mode === "large",
                  "flex items-center gap-32": _vm.mode === "small"
                }
              },
              [
                _c("form-input", {
                  staticClass: "dark",
                  attrs: {
                    name: "email",
                    placeholder: "e-mailadres",
                    rules: "required|email"
                  },
                  model: {
                    value: _vm.payload.email,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "email", $$v)
                    },
                    expression: "payload.email"
                  }
                }),
                _vm._v(" "),
                _vm.mode === "large"
                  ? _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checked,
                            expression: "checked"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "checkbox",
                          required: "true"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.checked)
                            ? _vm._i(_vm.checked, null) > -1
                            : _vm.checked
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.checked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.checked = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.checked = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "text-white",
                          attrs: { for: "checkbox" }
                        },
                        [
                          _vm._v("Ik heb de "),
                          _c(
                            "a",
                            {
                              staticClass: "underline",
                              attrs: { href: "/privacybeleid" }
                            },
                            [_vm._v("gebruiksvoorwaarden")]
                          ),
                          _vm._v(" gelezen en ga akkoord.")
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "form-submit",
                      {
                        staticClass: "!bg-orange !text-white",
                        attrs: {
                          disabled: invalid || !_vm.checked,
                          loading: loading,
                          success: success
                        }
                      },
                      [_vm._v("schrijf je in")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.mode === "small"
              ? _c("div", { staticClass: "mt-24" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checked,
                        expression: "checked"
                      }
                    ],
                    attrs: { type: "checkbox", id: _vm._uid, required: "true" },
                    domProps: {
                      checked: Array.isArray(_vm.checked)
                        ? _vm._i(_vm.checked, null) > -1
                        : _vm.checked
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.checked,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.checked = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.checked = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "text-white", attrs: { for: _vm._uid } },
                    [
                      _vm._v("Ik heb de "),
                      _c(
                        "a",
                        {
                          staticClass: "underline",
                          attrs: { href: "/privacybeleid" }
                        },
                        [_vm._v("gebruiksvoorwaarden")]
                      ),
                      _vm._v(" gelezen en ga akkoord.")
                    ]
                  )
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }